import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FaqSection() {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true }) as { q: string; a: string }[];
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("faq.title")}
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-600">
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg transition-transform`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}